import { FC } from 'react';
import { Paper, Modal, FormControl, RadioGroup, FormControlLabel, Radio, Button, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { FreeTrialPopUpProps } from './types';
import CheckIcon from '@material-ui/icons/Check';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';
import TodayIcon from '@material-ui/icons/Today';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';

export const FreeTrialPopUp: FC<FreeTrialPopUpProps> = ({ open, handleClose }) => {
  const classes = useStyles();
  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      <Paper className={classes.paper} elevation={3}>
        <div className={classes.flexBox}>
          <div className={classes.leftBox}>
            <div className={classes.heading}>
              <Button onClick={handleClose} className={classes.closeIcon}>
                <ArrowBackIosIcon className={classes.backIcon} />
              </Button>
              TRY FOR FREE EASY <span className={classes.red}>ID</span>ENTITY
            </div>
            <div className={classes.text}>
              <CheckIcon className={classes.checkIcon} /> Free trial for 30 days. You can cancel your subscription at
              any time.
            </div>
            <div className={classes.text}>
              <CheckIcon className={classes.checkIcon} /> We will send you a reminder before the end of the trial
              period.
            </div>
            <FormControl>
              <RadioGroup
                aria-labelledby='demo-radio-buttons-group-label'
                defaultValue='yearly'
                name='radio-buttons-group'>
                <FormControlLabel
                  value='yearly'
                  control={<Radio color='primary' />}
                  label={<Typography className={classes.title}>Yearly Subscription</Typography>}
                />
                <p className={`${classes.subtext} ${classes.marginLeft}`}>$119.99 ($9.99/monthly)</p>
                <FormControlLabel
                  value='monthly'
                  control={<Radio color='primary' />}
                  label={<Typography className={classes.title}>Monthly</Typography>}
                />
                <p className={`${classes.subtext} ${classes.marginLeft}`}>$12.99</p>
              </RadioGroup>
            </FormControl>
            <hr className={classes.divider} />
            <div className={classes.flexBetween}>
              <div className={classes.subTitleText}>Due June 23, 2022</div>
              <div className={classes.subTitleText}>$119.99</div>
            </div>
            <div className={classes.flexBetween}>
              <div className={classes.title}>
                Due Today <span className={classes.green}>(30 days free)</span>
              </div>
              <div className={classes.title}>$0</div>
            </div>
            <p>&nbsp;</p>
            <Button className={classes.btn} variant='contained' color='primary' fullWidth>
              NEXT
            </Button>
            <p>&nbsp;</p>
            <p className={classes.subtext}>
              While you press next you are agree with our <span className={classes.link}>Privacy Policy</span> and{' '}
              <span className={classes.link}>Terms of Use</span>
            </p>
          </div>
          <div className={classes.rightBox}>
            <div className={classes.flexEnd}>
              <Button onClick={handleClose} className={classes.closeIcon}>
                <CloseIcon />
              </Button>
            </div>

            <div className={classes.card}>
              <div className={classes.flex}>
                <div className={classes.batch}>
                  <TodayIcon />
                </div>
                <div>
                  <div className={classes.title}>Free trial period begins today</div>
                  <div className={classes.subtext}>You can cancel it every time.</div>
                </div>
              </div>
            </div>
            <div className={classes.modal}>
              <div className={classes.verticalLine}></div>
            </div>
            <div className={classes.card}>
              <div className={classes.flex}>
                <div className={classes.batch}>
                  <NotificationsIcon />
                </div>
                <div>
                  <div className={classes.title}>5 July</div>
                  <div className={classes.subtext}>
                    We will send you a reminder before 3 days until end of trial period.
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.modal}>
              <div className={classes.verticalLine}></div>
            </div>
            <div className={classes.card}>
              <div className={classes.flex}>
                <div className={classes.batch}>
                  <SubscriptionsIcon />
                </div>
                <div>
                  <div className={classes.title}>8 July</div>
                  <div className={classes.subtext}>
                    The subscription will start automatically unless you cancel it during the trial period.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Paper>
    </Modal>
  );
};
